import React, { useEffect, useState } from "react";
import {
  Content,
  Row,
  Col,
  Box,
  Button,
  SimpleTable,
  Pagination,
} from "adminlte-2-react";
import _ from "lodash";
import controller from "../locales/duck";
import controllerServicios from "./duck";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../utils/Loader";
import PYG from "../utils/PYG";

function ServiciosList({ history, match }) {
  const dispatch = useDispatch();

  const modelServiciosHijos = useSelector((state) => state.serviciosHijos);
  const modelDelete = useSelector((state) => state.deleteServicio);

  const [serviciosHijos, setServiciosHijos] = useState(null);
  const [totalResultsServHijos, setTotalResultsServHijos] = useState(0);
  const [activePageServHijos, setActivePageServHijos] = useState(0);
  const [pageSizeServHijos, setPageSizeServHijos] = useState(5);

  useEffect(() => {
    const data = modelDelete?.data?.data;
    const error = modelDelete?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controllerServicios.duckDeleteServicio.actions.clear());
    }
    if (data) {
      handlePageServHijos(0);
      dispatch(controllerServicios.duckDeleteServicio.actions.clear());
    }
  }, [modelDelete]);

  useEffect(() => {
    const data = modelServiciosHijos?.data?.data;
    const error = modelServiciosHijos?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckServiciosHijos.actions.clear());
    }
    if (data) {
      setServiciosHijos(data.data.items);
      setTotalResultsServHijos(data.data.total);

      dispatch(controller.duckServiciosHijos.actions.clear());
    }
  }, [modelServiciosHijos]);

  useEffect(() => {
    dispatch(
      controller.serviciosHijosThunk(match.params.padreId, 1, pageSizeServHijos)
    );
  }, []);

  function handlePageServHijos(page) {
    setActivePageServHijos(page);
    setServiciosHijos([]);
    dispatch(
      controller.serviciosHijosThunk(
        match.params.padreId,
        page + 1,
        pageSizeServHijos
      )
    );
  }

  function eliminarServicio(id) {
    var answer = window.confirm(
      "Borrar un servicio eliminara y horarios por debajo de el. ¿Esta seguro?"
    );
    if (answer) {
    
      let datos = {
        id,
      };

      dispatch(controllerServicios.deleteServicioThunk(datos));
    }
  }

  return (
    <Content
      title="Lista de servicios"
      subTitle="Lista de servicios"
      browserTitle="Lista de servicios"
      show={false}
    >
      <Row>
        <Col md="12">
          <Box title="Servicios">
            <Button
              type="primary"
              text="Agregar"
              pullRight={true}
              onClick={() =>
                history.push(
                  `/nuevoServicioHijo/${match.params.localId}/${match.params.padreId}/${match.params.categoriaId}`
                )
              }
            />
            <div>
              <span>Total: {totalResultsServHijos}</span>
            </div>
            <Loader isLoading={modelServiciosHijos.loading}>
              {serviciosHijos && serviciosHijos.length > 0 ? (
                <SimpleTable
                  hover={true}
                  data={serviciosHijos.map((row, index) => {
                    return match.params.categoriaId ===
                      "60f806a5e3e9af972fe85c7a"
                      ? {
                          nombre: row.nombre,
                          estado: row.estado,
                          editar: (
                            <Button
                              type="primary"
                              text="Editar"
                              onClick={() =>
                                history.push(
                                  `/editServicio/${match.params.localId}/${row._id}/${match.params.categoriaId}`
                                )
                              }
                            />
                          ),
                          eliminar: (
                            <Button
                              type="danger"
                              text="Eliminar"
                              onClick={() => eliminarServicio(row._id)}
                            />
                          ),
                        }
                      : {
                          nombre: row.nombre,
                          estado: row.estado,
                          duracion: row.duracion,
                          precio: (
                            <PYG
                              value={String(row.precio)}
                              isNumericString={true}
                            />
                          ),
                          editar: (
                            <Button
                              type="primary"
                              text="Editar"
                              onClick={() =>
                                history.push(
                                  `/editServicio/${match.params.localId}/${row._id}/${match.params.categoriaId}`
                                )
                              }
                            />
                          ),
                          eliminar: (
                            <Button
                              type="danger"
                              text="Eliminar"
                              onClick={() => eliminarServicio(row._id)}
                            />
                          ),
                        };
                  })}
                  columns={
                    match.params.categoriaId === "60f806a5e3e9af972fe85c7a"
                      ? [
                          { title: "Nombre", data: "nombre" },
                          { title: "Estado", data: "estado" },
                          { title: "Editar", data: "editar" },
                          { title: "Eliminar", data: "eliminar" },
                        ]
                      : [
                          { title: "Nombre", data: "nombre" },
                          { title: "Duracion", data: "duracion" },
                          { title: "Precio", data: "precio" },
                          { title: "Estado", data: "estado" },
                          { title: "Editar", data: "editar" },
                          { title: "Eliminar", data: "eliminar" },
                        ]
                  }
                />
              ) : (
                <h4>No se han encontrado servicios</h4>
              )}
            </Loader>
            <Pagination
              activePage={activePageServHijos}
              pageSize={pageSizeServHijos}
              totalElements={totalResultsServHijos}
              onChange={handlePageServHijos}
              labels={{
                first: "Primera",
                last: "Última",
                previous: "Anterior",
                next: "Siguiente",
              }}
            />
            <div>
              <span>Total: {totalResultsServHijos}</span>
            </div>
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default ServiciosList;
